import Terms from '../terms/Terms'

export default Terms
